import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

interface cargoSemPlanoData {
  idEleicao: number,
  token: string,
  cargo?: any,
  editandoCargo?: boolean,
  confirmarCallback?: () => void
}

@Component({
  selector: 'app-confirma-cargo-sem-plano',
  templateUrl: './confirma-cargo-sem-plano.component.html',
  styleUrls: ['./confirma-cargo-sem-plano.component.scss']
})
export class ModalConfirmaCargoSemPlanoComponent implements OnInit {
  title: string;
  closeBtnName: string;
  header: string;
  cargoSemPlanoData: cargoSemPlanoData;
  token: string;
  idEleicao: number;
  novoCargo: any;
  editandoCargo: boolean = false;

  constructor(
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.token = this.cargoSemPlanoData.token;
    this.novoCargo = this.cargoSemPlanoData.cargo;
    this.editandoCargo = this.cargoSemPlanoData.editandoCargo;
    this.idEleicao = this.cargoSemPlanoData.idEleicao;
  }

  confirmarSemPlano() {
    if (this.cargoSemPlanoData.confirmarCallback) {
      this.cargoSemPlanoData.confirmarCallback();
    }
    this.bsModalRef.hide();
  }

  cancelar() {
    this.bsModalRef.hide();
  }
}